import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ActivitySelectorViewModel extends SelectorBaseViewModel<Activity> {
    constructor(parentViewModel: ViewModel, id: string = null) {
        super(parentViewModel, true);
        this.opcId = id;
    }

    public set opcId(v: string) { this._opcId = v; } public get opcId(): string { return this._opcId; } private _opcId: string;

    protected async loadData(): Promise<Activity[]> {
        let result = await ServerConnection.callServer('/Complex/OpcServices/GetOpcStructure', {
            OpcId: this.opcId
        })
        return result.Activities.map(x => {
            let a = new Activity(this);
            a.id = x.Id;
            a.title = `${x.Name} (${x.Code})`;
            return a;
        });
    }
}

export class Activity extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}